import { styled } from '@mui/material/styles';
import {
  SharedContainerStepsStyles,
  SharedStyledResultsWrapper,
  SharedColumnSummary,
  SharedColumnImage,
} from '../../shared/styles/sharedBookingStyles';

export const StyledResultsWrapper = styled('div')(
  ({ theme }) => `
    ${SharedStyledResultsWrapper({ theme })}
`,
);

export const ColumnSummary = styled('article')(
  ({ theme }) => `
  ${SharedContainerStepsStyles({ theme })};
  ${SharedColumnSummary({ theme })};
`,
);

export const StyledImage = styled('div')(
  ({ theme }) => `
  ${SharedColumnImage({ theme })};
`,
);

export const CalendarButtonsWrapper = styled('div')(
  ({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.DS_spacing(['xxs'])};
  margin: ${theme.DS_spacing(['md'])} 0;
`,
);
